const vatLocalStorageKey = 'roundtower-include-vat'
;(function () {
  const vatSwitchCheckbox = document.querySelector(
    '#vat-switch input[type=checkbox]'
  )

  if (vatSwitchCheckbox) {
    vatSwitchCheckbox.addEventListener('change', function (event) {
      if (event.target.checked) {
        localStorage.setItem(vatLocalStorageKey, 'true')
        document.querySelector('html').classList.add('include-vat')
      } else {
        localStorage.setItem(vatLocalStorageKey, 'false')
        document.querySelector('html').classList.remove('include-vat')
      }
    })

    document
      .querySelector('#vat-switch .off')
      .addEventListener('click', function () {
        vatSwitchCheckbox.checked = false
        vatSwitchCheckbox.dispatchEvent(new Event('change'))
      })

    document
      .querySelector('#vat-switch .on')
      .addEventListener('click', function () {
        vatSwitchCheckbox.checked = true
        vatSwitchCheckbox.dispatchEvent(new Event('change'))
      })
  }

  getPreferenceFromLocalStorage(vatSwitchCheckbox)
})()

function getPreferenceFromLocalStorage(checkbox) {
  const value = localStorage.getItem(vatLocalStorageKey)
  //first time user is visiting
  if (value === null) {
    localStorage.setItem(vatLocalStorageKey, 'true')
    document.querySelector('html').classList.add('include-vat')
  } else if (value === 'true') {
    localStorage.setItem(vatLocalStorageKey, 'true')
    document.querySelector('html').classList.add('include-vat')
  } else {
    localStorage.setItem(vatLocalStorageKey, 'false')
    checkbox.click()
  }
}
